var map = {
	"./btn_breast_off.svg": "332e",
	"./btn_colorectal_off.svg": "581d",
	"./btn_dementia_off.svg": "18b6",
	"./btn_dm_off.svg": "18e2",
	"./btn_heart_off.svg": "6ed7",
	"./btn_liver_off.svg": "8eee",
	"./btn_lung_off.svg": "b277",
	"./btn_prostate_off.svg": "97d6",
	"./btn_stomach_off.svg": "7a5e",
	"./btn_stroke_off.svg": "26f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1f91";